module.exports = __webpack_public_path__ + "static/main1-dc43549a1510731cf15011f30e82be5a.png";